import { render, staticRenderFns } from "./KeyDates.vue?vue&type=template&id=3ac48b22&"
import script from "./KeyDates.vue?vue&type=script&lang=js&"
export * from "./KeyDates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports